import type { ReactNode } from 'react';
import { useFormContext } from '../context/FormContext';

export function Modal({ modalId, children }: { modalId: string; children: ReactNode }) {
  const { modalService } = useFormContext();

  return (
    <section className="modal" id={modalId} style={{ display: 'none' }}>
      <div className="modal-inner">
        <div className="wrapper scroll-content-inner">
          <div className="modal__header mb-2">
            <button type="button" className="close-button" onClick={() => modalService.close(modalId)}>
              <span className="lines"></span>
              <span className="visuallyhidden">Close modal window</span>
            </button>
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}
